import { SlidersHorizontal, X } from 'lucide-react';

import { Button, IconButton } from './Button';

interface FilterBarProps {
  /** Сколько условий выбрано — число на кнопке. */
  active: number;
  /** Выбранное словами: «Прочитано · Фантастика». */
  summary: string;
  onOpen: () => void;
  onReset: () => void;
}

/**
 * Фильтр — одной строкой: кнопка «Фильтры», выбранное словами и сброс.
 *
 * Сами условия — в шторке (`FilterSheet`): на экране списка место отдано
 * списку, а что выбрано — видно и без шторки.
 */
export function FilterBar({ active, summary, onOpen, onReset }: FilterBarProps) {
  return (
    <div className="flex min-w-0 items-center gap-2">
      <Button
        size="sm"
        variant={active > 0 ? 'soft' : 'secondary'}
        className="shrink-0"
        iconLeft={<SlidersHorizontal size={16} aria-hidden />}
        onClick={onOpen}
      >
        Фильтры{active > 0 && <span data-numeric> · {active}</span>}
      </Button>
      {active > 0 && (
        <>
          <span className="min-w-0 flex-1 truncate text-[13px] text-muted">{summary}</span>
          <IconButton label="Сбросить фильтр" size="sm" onClick={onReset}>
            <X size={16} aria-hidden />
          </IconButton>
        </>
      )}
    </div>
  );
}
